import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Home from "../layouts/LayoutMain.vue";
import Login from "../layouts/LayoutLogin.vue";
import { getAuth } from "firebase/auth";

const routes: Array<RouteRecordRaw> = [
	{
		path: "/",
		name: "Home",
		component: Home,
		meta: {
			requiresAuth: true,
		},
		children: [
			// { path: "/Clientes", component: Clientes },
			{
				path: '',
				component: () => import("../layouts/Main.vue"),
			},
			{
				path: '/Clientes',
				component: () => import("../views/Clientes/Clientes.vue"),
			},
			{
				path: "/Categorias",
				component: () => import("../views/Categorias/Categorias.vue"),
			},
			{
				path: "/Productos",
				component: () => import("../views/Productos/Productos.vue"),
			},
			{
				path: "/Pedidos",
				component: () => import("../views/Pedidos/Pedidos.vue"),
			},
			{
				path: "/Captura",
				component: () => import("../views/Pedidos/Captura.vue"),
			},
			{
				path: "/Cotizacion",
				component: () => import("../views/Pedidos/Cotizacion.vue"),
			},
			{
				path: "/Cuentas",
				component: () => import("../views/Cuentas/Cuentas.vue"),
			},
			{
				path: "/Pagos",
				component: () => import("../views/Pagos/Pagos.vue"),
			},
			{
				path: "/Roles",
				component: () => import("../views/Roles/Roles.vue"),
			},
			{
				path: "/Usuarios",
				component: () => import("../views/Users/Users.vue"),
			},
		],
	},
	// {
	//   path: '/about',
	//   name: 'About',
	//   // route level code-splitting
	//   // this generates a separate chunk (about.[hash].js) for this route
	//   // which is lazy-loaded when the route is visited.
	//   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
	// },
	{
		path: "/login",
		name: "Login",
		component: Login,
		meta: {
			requiresAuth: false,
		},
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

router.beforeEach(async (to, from, next) => {
	const RA = to.meta.requiresAuth;
	const isAuth = getAuth().currentUser;
	if (!isAuth && RA) {
		next({ path: "/login" });
	} else if (isAuth && to.name === "Login") {
		next({ path: "/" });
	} else {
		next();
	}
});

export default router;
